module.exports = __webpack_public_path__ + "img/Kick_Sub.df467b83.png";